// Backend: Domain/Concretes/Commerce/Enums/OrderStatus.cs
export enum OrderStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    PaymentPending = 3,
    PaymentFailed = 4
}
